import Marquee from 'react-fast-marquee'

import { Flex } from 'components/common/flex/Flex'
import { Typography } from 'components/common/Typography/Typography'
import lightbulbIconImgSrc from 'components/ideasSection/assets/lightbulb-icon.gif'
import { ReactComponent as TitleDecoration } from 'components/ideasSection/assets/title-decoration.svg'
import styles from 'components/ideasSection/IdeasSection.module.scss'

export const IdeasSection = () => {
  return (
    <div className={styles.container}>
      <Flex direction="column" align="center">
        <Flex justify="center" align="center" className={styles.bulbAnimationContainer}>
          <img src={lightbulbIconImgSrc} alt="Lightbulb icon" className={styles.bulbIcon} />
        </Flex>
        <div className={styles.titleContainer}>
          <h2 className={styles.title}>
            Amazing Rises to the Top
          </h2>
          <TitleDecoration className={styles.titleDecoration} />
        </div>
        <Typography type="l-body" tag="p" className={styles.description}>
          Prioritization is the secret ingredient in our processes, ensuring transparency, collective focus, and
          fostering growth opportunities for individuals and teams.
        </Typography>
        <Marquee speed={125} className={styles.bottomContainer}>
          <p className={`${styles.bottomText} italic`}>
            • FOCUS • FOCUS • FOCUS • FOCUS • FOCUS • FOCUS • FOCUS • FOCUS • FOCUS • FOCUS • FOCUS • FOCUS
          </p>
        </Marquee>
      </Flex>
    </div>
  )
}
